<div class="input-criteria-autocomplete-multi-selection-wrapper">
  @for (selectedOptionsChip of state.selectedOptions; track selectedOptionsChip) {
    <ng-container *ngTemplateOutlet="selectedOptionsChipTemplate; context: {selectedOptionChip: selectedOptionsChip}"></ng-container>
  }
  <input #inputSearch
    type="text"
    data-cy="input-criteria-autocomplete-multi-selection-input"
    class="input-criteria-autocomplete-multi-selection-input-text"
    placeholder="{{inputPlaceholder}}"
    (input)="onSearchQueryInput($event.target)"
    (keydown.enter)="addChipsQuery()"
    />
</div>

<app-multi-select-dropdown
  [dropdownOpenMenu]="dropdownOpenMenu"
  (addSelectedOption)="addOption($event)"
  [deleteSelectedOption]="closeCode"
  [multiSelectDropdownLabel]="dropdownAutocompleteLabel()"
[options]="state.dropdownOptions"></app-multi-select-dropdown>

<ng-template #selectedOptionsChipTemplate let-selectedOptionChip="selectedOptionChip">
  <div class="input-criteria-autocomplete-multi-selection-chip">
    <div class="input-criteria-autocomplete-multi-selection-chip-text-wrapper">
      <app-tooltip message="{{selectedOptionChip.code}} - {{selectedOptionChip.name}}">
        <span class="input-criteria-autocomplete-multi-selection-chip-text"
        [attr.data-cy]="'input-criteria-autocomplete-multi-selection-chip-text-' + selectedOptionChip.code">{{selectedOptionChip.code}} - {{selectedOptionChip.name}}</span>
      </app-tooltip>
    </div>
    <button class="input-criteria-autocomplete-multi-selection-delete-button"
      [attr.data-cy]="'input-criteria-autocomplete-multi-selection-delete-button-' + selectedOptionChip.code"
      (click)="removeOption(selectedOptionChip.code)">
      <span class="iwp-icon-gen_close_l"></span>
    </button>
  </div>
</ng-template>